import React, { useState, useEffect } from 'react';
import { TestService } from '../service/TestService';

const testService = new TestService();

export default function QuestionImage({ questionId, type = 'main', width = 60, style, onClick, refresh }) {
    const [src, setSrc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setSrc(null);
        testService.getQuestionImage(questionId, type)
            .then(base64 => {
                if (cancelled) return;
                setSrc(base64 ? `data:image/png;base64,${base64}` : null);
                setLoading(false);
            })
            .catch(() => {
                if (!cancelled) setLoading(false);
            });
        return () => { cancelled = true; };
    }, [questionId, type, refresh]);

    if (loading) return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.2rem', color: '#aaa' }} />;
    if (!src) return null;

    return (
        <img
            src={src}
            alt=""
            width={width}
            className="shadow-2"
            style={{ borderRadius: '8px', border: '2px solid #eee', cursor: onClick ? 'pointer' : 'default', ...style }}
            title={onClick ? 'Clique para ampliar' : undefined}
            onClick={() => onClick && onClick(src)}
        />
    );
}
